import React from 'react';
import { observer } from 'mobx-react';
import {
    Grid,
    Switch,
    Tooltip,
} from '@material-ui/core';

import { Typography } from '../../components/Wrappers/Wrappers.jsx';
import Dialog from '../../commons/dialog/Dialog';
import useEcalWorldProfile from './useEcalWorldProfile';

function EcalWorldProfileSwitch (props) {
    const {
        devAccess,
        isPublic,
        confirmOpen,
        tooltipTitle,
        dialogTitle,
        dialogText,
        handleToggle,
        handleConfirm,
        handleCancel,
        renderErrorDialog,
    } = useEcalWorldProfile(props);

    // Temporarily only allow developers to access this.
    if (!devAccess) {
        return null;
    }

    return (
        <>
            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                style={{ marginBottom: 35 }}
            >
                <Grid item>
                    <Typography variant="body1">
                        Be Discoverable in ECAL World
                    </Typography>
                </Grid>
                <Grid item>
                    <Tooltip title={tooltipTitle}>
                        <Switch
                            checked={isPublic}
                            onClick={handleToggle}
                            color="primary"
                            inputProps={{ 'aria-label': 'Be Discoverable in ECAL World' }}
                        />
                    </Tooltip>
                </Grid>
            </Grid>

            <Dialog
                openDialog={confirmOpen}
                buttonSecondary={'Cancel'}
                handleAgree={handleConfirm}
                closeModal={handleCancel}
                title={dialogTitle}
                dialogContextText={dialogText}
            />

            { renderErrorDialog() }
        </>
    );
}

export default observer(EcalWorldProfileSwitch);
